import getFirebase from 'helper/getFirebase';
import { LiveClassEventType } from '../utils/consts';

async function getQuery(classId) {
  const { firebaseDB } = await getFirebase();
  const liveCLassCollection = firebaseDB.collection('live-class-events');
  return liveCLassCollection
    .where('classId', '==', classId)
    .where('type', '==', LiveClassEventType.CARD_COMPLETE)
    .orderBy('createdAt', 'desc');
}

function getCompletedCardsEventsFromSnapshot(snapshot) {
  if (snapshot.empty) {
    return [];
  }
  const docs = [];
  snapshot.forEach((docSnapshot) => {
    docs.push(docSnapshot.data());
  });
  return docs;
}

export async function fetchCompletedCardsSubscription(classId, callback) {
  const query = await getQuery(classId);
  return query.onSnapshot((snapshot) => {
    const events = getCompletedCardsEventsFromSnapshot(snapshot);
    if (!events) return;
    callback(events);
  });
}
